import { UserState, type UserInfo as ApiUserInfo } from "@b2bportal/auth-api";
import { CallState } from "@b2bportal/core-types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface UserInfo extends ApiUserInfo {
  isFirstSession: boolean;
  callState: CallState;
  loginState: CallState;
  userStateUpdated: boolean;
  shouldIgnoreUserStateUpdated: boolean;
}

export type EssentialUserInfo = Omit<
  UserInfo,
  "loginState" | "userStateUpdated" | "shouldIgnoreUserStateUpdated"
>;

const defaultUserInfo: UserInfo = {
  isFirstSession: false,
  userState: UserState.Anonymous,
  callState: CallState.NotCalled,
  loginState: CallState.NotCalled,
  userStateUpdated: false,
  shouldIgnoreUserStateUpdated: false,
};

export interface AuthInfo {
  userInfo: UserInfo;
}

export const authInfoSlice = createSlice({
  name: "authInfoSlice",
  initialState: defaultUserInfo,
  reducers: {
    setCallState: (state, action: PayloadAction<CallState>) => {
      state.callState = action.payload;
    },
    setLoginState: (state, action: PayloadAction<CallState>) => {
      state.loginState = action.payload;
    },
    setUserInfo: (state, action: PayloadAction<EssentialUserInfo>) => ({
      ...state,
      ...action.payload,
    }),
    setUserStateUpdated: (state) => {
      state.userStateUpdated = true;
    },
    setShouldIgnoreUserStateUpdated: (state) => {
      state.shouldIgnoreUserStateUpdated = true;
    },
    setFirstSession: (state, action: PayloadAction<boolean>) => {
      state.isFirstSession = action.payload;
    },
    clearUserInfo: () => defaultUserInfo,
  },
});

export const AuthInfoActions = authInfoSlice.actions;
